export default __webpack_public_path__ + "static/media/single_web-lg@1x.da418491.webp";